import { PageBuilderTextPropertiesModel } from "@de-trustleap/shared-models";
import { BaseWidget } from "./baseWidget";
import { replacePlaceholdersFromContext } from "../utils/placeholderUtils";

export class TextWidget extends BaseWidget<PageBuilderTextPropertiesModel> {
  private alignment: string;

  constructor(properties: PageBuilderTextPropertiesModel) {
    super(properties);
    this.alignment = properties.alignment ?? "left";
  }

  async render(): Promise<HTMLElement> {
    const wrapper = this.createWrapper();
    const element = this.createTextElement();
    wrapper.appendChild(element);
    return wrapper;
  }

  private createWrapper(): HTMLElement {
    const wrapper = document.createElement("div");
    wrapper.classList.add("text-widget");
    this.applyStyles(wrapper, {
      width: "100%",
      height: "auto",
      boxSizing: "border-box",
      textAlign: this.alignment,
    });
    return wrapper;
  }

  private createTextElement(): HTMLElement {
    const element = document.createElement("div");

    this.applyStyles(element, {
      display: "inline-block",
      wordBreak: "break-word",
      whiteSpace: "normal",
      fontSize: `${this.properties.fontSize ?? 16}px`,
      color: this.formatColor(this.properties.color, "#333333"),
      fontFamily: this.properties.fontFamily ?? "Arial, sans-serif",
      fontWeight: this.properties.isBold ? "600" : "400",
      fontStyle: this.properties.isItalic ? "italic" : "normal",
      letterSpacing: `${this.properties.letterSpacing ?? 1.2}px`,
      lineHeight: `${this.properties.lineHeight ?? 1.5}`,
      textAlign: this.alignment,
    });

    const rawText = this.properties.text ?? "";
    const finalText = replacePlaceholdersFromContext(rawText);  // ✅ Jetzt preview-safe

    element.textContent = finalText;

    if (this.properties.textShadow) {
      element.style.textShadow = this.getTextShadow(this.properties.textShadow);
    }

    return element;
  }

  private getTextShadow(shadow: { offset?: { x?: number; y?: number }; blurRadius?: number; color?: string }): string {
    const offsetX = shadow.offset?.x ?? 0;
    const offsetY = shadow.offset?.y ?? 0;
    const blurRadius = shadow.blurRadius ?? 0;
    return `${offsetX}px ${offsetY}px ${blurRadius}px ${this.formatColor(shadow.color, "#000000")}`;
  }
}
